<script lang="ts">
    import { Col,Progress } from "sveltestrap";
    import { Multiplebars } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Card cardHeaderprops="pb-0" CardBodyprops="progress-showcase row" headerTitle={Multiplebars} headerContent="Include multiple progress bars in a progress component if you need.">
  <div slot="contentbody">
    <Col>
      <Progress multi>
        <Progress bar value={30} color="primary">
        </Progress>
        <Progress bar value={20} color="secondary">
        </Progress>
        <Progress bar value={15} color="success">
        </Progress>
      </Progress>
      <Progress multi>
        <Progress bar value={10} color="primary">
        </Progress>
        <Progress bar value={10} color="secondary">
        </Progress>
        <Progress bar value={10} color="success">
        </Progress>
        <Progress bar value={10} color="info">
        </Progress>
        <Progress bar value={10} color="warning">
        </Progress>
        <Progress bar value={10} color="danger">
        </Progress>
        <Progress bar value={10} color="primary">
        </Progress>
        <Progress bar value={10} color="light">
        </Progress>
      </Progress>
    </Col>
  </div>
</Card>
